/* eslint-disable-next-line padded-blocks */
import { useEffect, useState } from "react";
import { ptBR } from "date-fns/locale";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { format, subDays } from "date-fns";


import html2pdf from "html2pdf.js";
import ReactDOMServer from "react-dom/server";
import * as XLSX from "xlsx";

//primereact
import { Button } from "primereact/button";
import { Skeleton } from "primereact/skeleton";
import { BreadCrumb } from "primereact/breadcrumb";
import { RadioButton } from "primereact/radiobutton";
//components
import Panel from "../../../components/panel/panel";
import Select from "../../../components/input/Select";
import ModelReport from "../../../components/report/ModelReport";
import CalendarInput from "../../../components/input/CalendarInput";
//pages
import TableDebtorReport from "./TableDebtorReport";
//services
import { useOptionsSelect } from "../../../hooks/useOptionsSelect";
import { postReportInfringement } from "../../../services/Report/postReportInfringement";
//utils
import { useAppContext } from "../../../context/AppContext";
import { formatCurrency } from "../../../utils/formatCurrency";
import usePermission from "../../../hooks/usePermission";

export default function Debtor() {
  const { permissions } = useAppContext();
  usePermission("129"); //Visualizar Relatorio de Inadimplencia

  const [now, setNow] = useState("");
  const [logo, setLogo] = useState();
  const [user, setUser] = useState("");
  const [table, setTable] = useState();
  const [loading, setLoading] = useState();
  const [filters, setFilters] = useState([]);
  const [visible, setVisible] = useState(false);
  const [radioButton, setRadioButton] = useState("");

  const form = useForm();
  const errors = form.formState.errors;

  const yesterday = subDays(new Date().setHours(0,0,0,0), 1);

  const items = [
    {
      template: () => (
        <Link to={"/reports/debtor"} className="p-breadcrumb-link">
          Inadimplência
        </Link>
      ),
    },
  ];

  const home = {
    template: () => (
      <Link to={"#"} className="p-breadcrumb-link">
        <i className="fa fa-home"></i>
      </Link>
    ),
  };

  const { client, enterprise, isLoadingClients, isLoadingEnterprises } =
    useOptionsSelect();

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return format(date, "dd/MM/yyyy");
  };

  const formatDateToISO = (dateString) => {
    const [day, month, year] = dateString.split("/");
    const isoDate = `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    return isoDate;
  };

  const onSubmit = async (data) => {
    if (radioButton === "") {
      toast.warning("O período é obrigatório!");
      return;
    }
    // console.log(data);
    const today = new Date();
    const formattedDate = format(today, "dd 'de' MMMM 'de' yyyy", {
      locale: ptBR,
    });
    setNow(formattedDate);

    setLoading(true);

    let startDate;
    let endDate = subDays(new Date(), 1);
    switch (radioButton) {
      case "30Days":
        startDate = formatDate(subDays(endDate, 30));
        endDate = format(endDate, "dd/MM/yyyy");
        data.start_date = formatDateToISO(startDate);
        data.end_date = formatDateToISO(endDate);
        break;
      case "60Days":
        startDate = formatDate(subDays(endDate, 60));
        endDate = format(endDate, "dd/MM/yyyy");
        data.start_date = formatDateToISO(startDate);
        data.end_date = formatDateToISO(endDate);
        break;
      case "90Days":
        startDate = formatDate(subDays(endDate, 90));
        endDate = format(endDate, "dd/MM/yyyy");
        data.start_date = formatDateToISO(startDate);
        data.end_date = formatDateToISO(endDate);
        break;
      case "period":
        startDate = format(data.start_date, "dd/MM/yyyy");
        endDate = format(data.end_date, "dd/MM/yyyy");
        break;
      default:
        break;
    }
    // console.log(startDate);
    // console.log(endDate);
    // console.log("data", data);

    let enterpriseLabel = "";
    let clientLabel = "";

    if (data.client_id) {
      clientLabel = client.find((item) => item.value === data.client_id)?.label;
    }

    if (data.enterprise_id) {
      enterpriseLabel = enterprise.find(
        (item) => item.value === data.enterprise_id
      )?.label;
    }

    const newFilters = [
      { title: "Cliente", content: clientLabel },
      { title: "Empreendimento", content: enterpriseLabel },
      { title: "Período", content: `de ${startDate} até ${endDate}` },
    ];

    setFilters(newFilters);

    const notification = toast.loading(
      "Por favor aguarde a consulta está sendo realizada..."
    );
    try {
      const response = await postReportInfringement(data);
      setTable(response);
      setLogo(enterpriseLabel && response.enterprises[enterpriseLabel]?.img);
      setUser(response.user.name);
      toast.update(notification, {
        render: "Consulta Realizada!",
        autoClose: 1000,
        theme: "colored",
        type: "success",
        isLoading: false,
      });
      setLoading(false);
      setVisible(true);
    } catch (e) {
      console.log(e);
      toast.update(notification, {
        render: "Houve um erro a buscar os dados, tente novamente",
        type: "error",
        theme: "colored",
        autoClose: 5000,
        isLoading: false,
      });
      setLoading(false);
    }
  };

  const handlePrint = () => {
    const headerContent = (
      <div style={{ color: "#000000" }}>
        <div>
          <div className="header-contract-land pt-3 pb-2">
            <div className="row">
              <div className="col-md-3 d-flex justify-content-center">
                {logo && <img src={logo} alt="logo" width={100} />}
              </div>
              <div className="col-md-6 text-center pt-4">
                <h3 className="fw-bolder">RELATÓRIO DE INADIMPLÊNCIA</h3>
              </div>
              <div className="col-md-3 d-flex justify-content-end pt-4">
                <div className="mx-3 text-center">
                  <h6>{now}</h6>
                  <p style={{ fontSize: "9px" }}>Emitido por: {user}</p>
                </div>
              </div>
            </div>
            <div className="row text-center d-flex justify-content-center my-2">
              {filters.map((item, index) => (
                <div className="col-md-4" key={index}>
                  <h6 className="mx-3">
                    {item.title}: {item.content}
                  </h6>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="table-content">
          <div className="my-1 text-center overflow-hidden">
            <TableDebtorReport table={table && table} />
            <div
              className="row fw-bolder border-top mt-3"
              style={{
                backgroundColor: "#b8b8b8",
                color: "#2D2D2D",
              }}
            >
              <div className="col-md-6 text-end pt-2">
                <p>Total Geral:</p>
              </div>
              <div className="col-md-2 pt-2">
                <p>{formatCurrency(table.total_value)}</p>
              </div>
              <div className="col-md-1 pt-2">
                <p>{formatCurrency(table.total_fine)}</p>
              </div>
              <div className="col-md-1 pt-2">
                <p>{formatCurrency(table.total_fee)}</p>
              </div>
              <div className="col-md-2 pt-2">
                <p>{formatCurrency(table.total_value_fine_fee)}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
    const htmlString = ReactDOMServer.renderToString(headerContent);
    const options = {
      margin: 27,
      filename: "relatorio_inadimplencia.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "pt", format: "letter", orientation: "portrait" },
    };

    const addPageNumbers = (pdf) => {
      const totalPages = pdf.internal.getNumberOfPages();
      for (let i = 1; i <= totalPages; i++) {
        pdf.setPage(i);
        pdf.setFontSize(10);
        pdf.setTextColor(100);
        pdf.text(
          `Página ${i} de ${totalPages}`,
          pdf.internal.pageSize.getWidth() - 100,
          pdf.internal.pageSize.getHeight() - 15
        );
      }
    };

    const generatePDF = () => {
      // const pdf = new jsPDF(options.jsPDF);
      html2pdf()
        .from(htmlString)
        .set(options)
        .toPdf()
        .get("pdf")
        .then(function (pdfDoc) {
          addPageNumbers(pdfDoc);
          pdfDoc.save(options.filename);
        });
    };
    generatePDF();
  };
  const handleExcelExport = () => {
    if (
      !table ||
      !table.enterprises ||
      typeof table.enterprises !== "object" ||
      Object.keys(table.enterprises).length === 0
    ) {
      // toast.error("Dados não disponíveis para exportação!");
      return;
    }
    const excelData = [];
    
    Object.keys(table.enterprises).forEach(enterpriseId => {
      const enterprise = table.enterprises[enterpriseId];
      
      Object.keys(enterprise.clients).forEach(clientId => {
        const client = enterprise.clients[clientId];
        
        Object.keys(client.lands).forEach(landId => {
          const land = client.lands[landId];
          
          land.installments.forEach(installment => {
            excelData.push({
              "Empreendimento": enterprise.name,
              "Cliente": client.name_cli,
              "Telefone": client.contact_cli || "",
              "Quadra/Setor": installment.block || "",
              "Lote": installment.land || "",
              "Parcela": installment.sequence_number || "",
              "Descrição": installment.description || "",
              "Data Vencimento": installment.due_date || "",
              "Dias Atraso": installment.delay || "",
              "Valor": formatCurrency(parseFloat(installment.value || 0).toFixed(2)),
              "Multa": formatCurrency(parseFloat(installment.fine || 0).toFixed(2)),
              "Juros": formatCurrency(parseFloat(installment.fee || 0).toFixed(2)),
              "Total": formatCurrency(parseFloat(installment.value_fine_fee || 0).toFixed(2))
            });
          });
        });
      });
    });

    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Inadimplência");

    const excelFileName = `relatorio_inadimplencia_${format(
      new Date(),
      "dd-MM-yyyy"
    )}.xlsx`;
    XLSX.writeFile(workbook, excelFileName);
    // toast.success("Relatório exportado com sucesso!");
  };

  return (
    <>
      <div className="row d-flex justify-content-between mb-3">
        <div>
          <BreadCrumb
            model={items}
            home={home}
            style={{
              background: "transparent",
              border: "none",
              fontSize: "16px",
            }}
          />
        </div>
        <Panel title="Inadimplência">
          <form onSubmit={form.handleSubmit(onSubmit)}>
            <div className="row d-flex mt-4">
              <div className="col-xl-3 col-md-6 mb-3 form-group">
                <Select
                  name="client_id"
                  control={form.control}
                  label={isLoadingClients ? "Carregando..." : "Cliente"}
                  disabled={isLoadingClients}
                  options={client}
                  errors={errors}
                />
              </div>
              <div className="col-xl-3 col-md-6 mb-3 form-group">
                <Select
                  name="enterprise_id"
                  control={form.control}
                  label={
                    isLoadingEnterprises ? "Carregando..." : "Empreendimento"
                  }
                  disabled={isLoadingEnterprises}
                  options={enterprise}
                  errors={errors}
                />
              </div>
              <div className="col-xl-3 col-md-6 d-flex justify-content-between">
                <div className="pt-4">
                  <RadioButton
                    name="90Days"
                    value="90Days"
                    checked={radioButton === "90Days"}
                    onChange={(e) => setRadioButton(e.value)}
                  />
                  <label className="mx-2">90 Dias</label>
                </div>
                <div className="pt-4">
                  <RadioButton
                    name="60Days"
                    value="60Days"
                    checked={radioButton === "60Days"}
                    onChange={(e) => setRadioButton(e.value)}
                  />
                  <label className="mx-2">60 Dias</label>
                </div>
                <div className="pt-4">
                  <RadioButton
                    name="30Days"
                    value="30Days"
                    checked={radioButton === "30Days"}
                    onChange={(e) => setRadioButton(e.value)}
                  />
                  <label className="mx-2">30 Dias</label>
                </div>
                <div className="pt-4">
                  <RadioButton
                    name="period"
                    value="period"
                    checked={radioButton === "period"}
                    onChange={(e) => setRadioButton(e.value)}
                  />
                  <label className="mx-2">Período</label>
                </div>
              </div>
              {radioButton === "period" && (
                <div className="row justify-content-end">
                  <div className="col-xl-3 col-md-6 mb-3 form-group">
                    <CalendarInput
                      name="start_date"
                      control={form.control}
                      errors={errors}
                      isRequired={true}
                      maxDate={yesterday}
                      label="Data Inicial"
                    />
                  </div>
                  <div className="col-xl-3 col-md-6 mb-3 form-group">
                    <CalendarInput
                      name="end_date"
                      control={form.control}
                      errors={errors}
                      isRequired={true}
                      maxDate={yesterday}
                      label="Data Final"
                    />
                  </div>
                </div>
              )}
              <div className="d-flex justify-content-end my-2">
                <div
                  className={`${
                    window.innerWidth <= 992 ? "w-25" : "col-md-1"
                  } text-center`}
                >
                  <Button
                    type="submit"
                    icon="fa fa-search"
                    aria-label="Search"
                    loading={loading}
                    className={`rounded-3 py-2.5 w-100`}
                  />
                </div>
              </div>
            </div>
          </form>
        </Panel>

        {loading && (
          <Skeleton width="100%" height="600px" className="mt-4"></Skeleton>
        )}

        {visible && !loading && (
          <Panel mainCss="mt-4">
            <>
              {/* <hr className="my-4" /> */}
              <div className="px-2 pb-3">
                <div className="d-flex gap-2 mb-3 justify-content-end">
                  <Button
                    onClick={() => handlePrint()}
                    icon="fa fa-file-pdf"
                    className="p-button-secondary cursor-pointer"
                    rounded
                    tooltip="Exportar PDF"
                  />
                  <Button
                    icon="fa fa-file-excel"
                    className="p-button-success cursor-pointer"
                    rounded
                    tooltip="Exportar Excel"
                    tooltipOptions={{
                      position: "bottom",
                    }}
                    onClick={handleExcelExport}
                  />
                </div>
                <ModelReport
                  date={now}
                  madeBy={user}
                  logo={logo}
                  title="RELATÓRIO DE INADIMPLÊNCIA"
                  filters={filters}
                >
                  <div className="text-center overflow-hidden">
                    {Object.keys(table.enterprises).length !== 0 ? (
                      <TableDebtorReport table={table && table} />
                    ) : (
                      <div className="d-flex flex-column align-items-center mt-4">
                        <h4
                          className="bg-light p-3 rounded-pill fw-bolder mt-4"
                          style={{ translate: "0px -20px" }}
                        >
                          Nenhuma Informação Encontrada
                        </h4>
                      </div>
                    )}
                    {Object.keys(table.enterprises).length !== 0 && (
                      <div
                        className="row fw-bolder border-top my-3"
                        style={{
                          backgroundColor: "#b8b8b8",
                          color: "#2D2D2D",
                        }}
                      >
                        <div className="col-md-6 text-end pt-2">
                          <p>Total Geral:</p>
                        </div>
                        <div className="col-md-1 pt-2">
                          <p>{formatCurrency(table.total_value.toFixed(2))}</p>
                        </div>
                        <div className="col-md-1 pt-2">
                          <p>{formatCurrency(table.total_fine.toFixed(2))}</p>
                        </div>
                        <div className="col-md-1 pt-2">
                          <p>{formatCurrency(table.total_fee.toFixed(2))}</p>
                        </div>
                        <div className="col-md-2 pt-2">
                          <p>
                            {formatCurrency(
                              table.total_value_fine_fee.toFixed(2)
                            )}
                          </p>
                        </div>
                      </div>
                    )}
                  </div>
                </ModelReport>
              </div>
            </>
          </Panel>
        )}
      </div>
    </>
  );
}
